import React from 'react';
import StepperInput from './StepperInput';
import './MultiServiceRow.css';

/**
 * F5 — Multi-service booking policy row.
 *
 * Left cluster:  big iOS-style toggle + bold title + ON/OFF chip + helper text.
 * Right cluster: MAX PER BOOKING overline + StepperInput + range footnote.
 *
 * The stepper is auto-disabled when the toggle is off (separate from the
 * card-level edit-mode disabled, which applies to both controls).
 */
const MultiServiceRow = ({
  enabled,
  maxAllowed,
  onEnabledChange,
  onMaxChange,
  onMaxBlur,
  disabled = false,
}) => {
  const isOn = enabled !== false;
  const stepperDisabled = disabled || !isOn;

  return (
    <div className={`appointments-v3-multi-row ${disabled ? 'is-disabled' : ''}`}>
      <div className="appointments-v3-multi-row-left">
        <button
          type="button"
          role="switch"
          aria-checked={isOn}
          aria-label="Allow multi-service bookings"
          disabled={disabled}
          onClick={() => onEnabledChange?.(!isOn)}
          className={`appointments-v3-multi-switch ${isOn ? 'is-on' : ''}`}
        >
          <span className="appointments-v3-multi-switch-thumb" aria-hidden="true" />
        </button>

        <div className="appointments-v3-multi-row-text">
          <div className="appointments-v3-multi-row-title-line">
            <span className="appointments-v3-multi-row-title">Allow multi-service bookings</span>
            <span className={`appointments-v3-multi-row-chip ${isOn ? 'is-on' : 'is-off'}`}>
              {isOn ? 'ON' : 'OFF'}
            </span>
          </div>
          <p className="appointments-v3-multi-row-subtitle">
            Customers and walk-in operators can add more than one service per booking, capped by the
            limit on the right. When off, every booking is single-service.
          </p>
        </div>
      </div>

      <div className="appointments-v3-multi-row-right">
        <span className="appointments-v3-multi-row-overline">MAX PER BOOKING</span>
        <StepperInput
          value={maxAllowed ?? null}
          min={1}
          max={10}
          disabled={stepperDisabled}
          ariaLabel="Max services per booking"
          allowTyping
          onChange={onMaxChange}
          onBlur={onMaxBlur}
        />
        <span className="appointments-v3-multi-row-footnote">Range 1–10</span>
      </div>
    </div>
  );
};

export default MultiServiceRow;
